import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { Card, CardColors, Icon, Image, List, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const HeardListItem = ({
  contentText,
  subtext,
  subtextVariant,
}: {
  contentText: string
  subtext?: string
  subtextVariant?: TypographyStyles
}) => (
  <List.Item className="flex items-start gap-1">
    <Icon
      color="text-green-100"
      icon={faCheck}
      className="text-[16px] mt-0.5"
    />
    <div className="flex-1 flex flex-col">
      <Text>{contentText}</Text>
      {subtext && (
        <Text variant={subtextVariant} color={TextColors.MUTED}>
          {subtext}
        </Text>
      )}
    </div>
  </List.Item>
)

export const WhatYouGetCard = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <Card color={CardColors.LEVEL_1}>
        <Text variant={TypographyStyles.H2}>What you get with Heard</Text>

        <List className="mt-6 flex flex-col gap-1">
          <HeardListItem contentText="Your books organized every month" />
          <HeardListItem contentText="No surprises at tax time" />
          <HeardListItem contentText="A support team who knows therapy practices" />
          <HeardListItem contentText="Personal and business taxes, filed for you" />
          <HeardListItem contentText="A clear picture of your practice finances" />
        </List>
      </Card>

      <div className="p-6">
        <div className="flex flex-col items-center">
          <Image
            className="w-12 h-12 rounded-full"
            aspectRatio="1/1"
            src="https://heard-images.s3.amazonaws.com/assets/signup/therapist-profile-pic-2.jpg"
            alt="Michelle Vo"
          />
          <Text variant={TypographyStyles.LABEL_XS} className="mt-2">
            Michelle Vo
          </Text>
          <Text variant={TypographyStyles.BODY_XS}>LCSW</Text>
        </div>

        <Text
          className="mt-4"
          variant={TypographyStyles.BODY_XS}
          textAlign="center"
          color={TextColors.MUTED}
        >
          &ldquo;Heard has supported my business in more ways than I can
          express! Since partnering with them in 2021, they&apos;ve provided
          invaluable assistance with my personal tax returns, quarterly tax
          filings, and establishing payroll for my S Corporation&rdquo;
        </Text>
      </div>
    </div>
  )
}
